// frontend/src/features/citysense/housing-stock-modeller/components/RetrofitReferenceTable.tsx

import React, { useState } from 'react';
import { RETROFIT_DATA } from '../constants/housingConfig';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const RetrofitReferenceTable: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="bg-white rounded-xl border-2 border-teal-200 overflow-hidden shadow-sm">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 flex items-center justify-between hover:bg-teal-50 transition-colors"
      >
        <h4 className="text-sm font-bold text-teal-700">
          Retrofit Cost & GHG Savings Reference Table (per house, by GIS age class)
        </h4>
        {isExpanded ? (
          <ChevronUp className="w-5 h-5 text-teal-600" />
        ) : (
          <ChevronDown className="w-5 h-5 text-teal-600" />
        )}
      </button>

      {isExpanded && (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-teal-50">
                <th className="px-4 py-3 text-left font-semibold uppercase tracking-wider text-teal-800">
                  GIS Age Class
                </th>
                <th className="px-4 py-3 text-right font-semibold uppercase tracking-wider text-teal-800">
                  Retrofit Cost / House
                </th>
                <th className="px-4 py-3 text-right font-semibold uppercase tracking-wider text-teal-800">
                  Annual Avoided GHG
                </th>
                <th className="px-4 py-3 text-right font-semibold uppercase tracking-wider text-teal-800">
                  20-yr Operational GHG Saving
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(RETROFIT_DATA).map(([ageClass, data], index) => (
                <tr 
                  key={ageClass} 
                  className={`border-t border-teal-100 hover:bg-teal-50 transition-colors ${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                  }`}
                >
                  <td className="px-4 py-3 font-semibold text-gray-800">{ageClass}</td>
                  <td className="px-4 py-3 text-right font-mono text-gray-700">
                    €{data.cost.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 text-right font-mono text-gray-700">
                    {data.annualGHG} tCO₂e
                  </td>
                  <td className="px-4 py-3 text-right font-mono text-gray-700">
                    {data.twentyYear} tCO₂e
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="p-4 bg-gradient-to-br from-teal-50 to-cyan-50 text-xs text-gray-700 leading-relaxed border-t border-teal-200">
            <p className="mb-2">
              <strong className="text-teal-700">Source:</strong> households_included.geojson — Dublin City Small Areas
            </p>
            <p>
              This project's 7 housing archetypes group buildings into 4 broader eras (Pre-1945 / 1946–1980 / 1981–2000 / Post-2000) 
              than the 6 GIS age classes above. Where an archetype era spans two GIS classes, its cost and GHG figures are the average 
              of those two classes. Retrofit economics are applied <strong>per dwelling</strong> using each Small Area's actual 
              Dwellings_2022 count (houses + flats), not a flat assumption.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};